/**
 * Popover/typed.ts
 * desc: typed view of the still-JS Popover for components written in TypeScript
 * note: delete when Popover converts — the cast masks its real signature
 */
import type { ComponentType, ReactNode } from 'react';
import PopoverUntyped from './index';

type Side = 'top' | 'right' | 'bottom' | 'left';

export interface PopoverProps {
    align?: 'start' | 'center' | 'end';
    alignOffset?: number;
    arrow?: boolean;
    asChild?: boolean;
    // the trigger
    children: ReactNode;
    collisionPadding?: number | Partial<Record<Side, number>>;
    content: ReactNode;
    contentClassname?: string;
    modal?: boolean;
    onCloseAutoFocus?: (event: Event) => void;
    onInteractOutside?: (event: Event) => void;
    onOpenAutoFocus?: (event: Event) => void;
    onOpenChange?: (open: boolean) => void;
    open?: boolean;
    side?: Side;
    sideOffset?: number;
    triggerClassname?: string;
}

const Popover = PopoverUntyped as unknown as ComponentType<PopoverProps>;

export default Popover;
